/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `1` - Full payment
 * * `2` - 2 installments
 * * `3` - 3 installments
 * * `4` - 4 installments
 */
export enum InstallmentsEnum {
  '_1' = 1,
  '_2' = 2,
  '_3' = 3,
  '_4' = 4,
}
